import React, { FC } from 'react'
import AchDebitContainer from 'containers/ACHDebit'

const AchDebitPage: FC = () => <AchDebitContainer />

export default AchDebitPage
